<template>
    <div class="modal fade custom-modal" id="publicContactModalProject" data-hashtag="contact" tabindex="-1" role="dialog"
         aria-labelledby="newProjectModalTitle" aria-hidden="true" data-keyboard="false">
        <div class="top-modal-mask" data-dismiss="modal" aria-label="Close"></div>
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content custom-modal-content new-project-modal-content">
                <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                    <i class="fad fa-times-circle"></i>
                </div>
                <div class="modal-header custom-modal-header">
                    <i class="fad fa-address-card"></i>
                    <h5 class="modal-title"> Contacteaza-ne! </h5>
                    <p>Afla mai multe detalii sau programeaza o vizionare</p>
                </div>

                <form id="publicContactModalProjectForm">
                    <input type="hidden" v-if="project" name="project" :value="project.id">
                    <input type="hidden" v-if="project" name="receiver" :value="project.user.email">
                    <input type="hidden" name="category" value="lead">
                    <div class="modal-body custom-modal-body">
                        <ul class="modal-contact-list mb-4"
                            v-if="project && project.contacts && project.contacts.length > 0">
                            <li v-for="contact in project.contacts" :key="contact.id">
                                <h5 v-if="contact.name">
                                    <i class="fad fa-user-tie"></i>
                                    <span> {{contact.name}} </span>
                                </h5>
                                <p>
                                    <a v-if="contact.phone" :href="`tel:${contact.phone}`" class="phone-link">
                                        <i class="fad fa-phone-rotary"></i>
                                        <span><strong> {{contact.phone}} </strong></span>
                                    </a>
                                    <a v-if="contact.email" :href="`mailto:${contact.email}`">
                                        <i class="fad fa-at"></i>
                                        <span> {{contact.email}} </span>
                                    </a>
                                </p>
                            </li>
                        </ul>
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <input type="email" id="contact_email" name="sender_email" v-model="email"
                                       placeholder="* Email">
                                <div class="input-icon">
                                    <i class="fad fa-at"></i>
                                </div>
                                <label class="custom-label" for="contact_email"> Email </label>
                            </div>
                            <p class="custom-input-error" id="sender_email_error"></p>
                        </div>
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <input type="number" id="contact_phone" name="sender_phone" v-model="phone"
                                       placeholder="Telefon">
                                <div class="input-icon">
                                    <i class="fad fa-phone-rotary"></i>
                                </div>
                                <label class="custom-label" for="contact_phone"> Telefon </label>
                            </div>
                            <p class="custom-input-error" id="sender_phone_error"></p>
                        </div>
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <textarea type="text" id="contact_message" name="body" rows="5" placeholder="Mesaj"
                                          v-model="message"></textarea>
                                <div class="input-icon">
                                    <i class="fad fa-pencil-alt"></i>
                                </div>
                                <label class="custom-label" for="contact_message"> Mesaj </label>
                            </div>
                            <p class="custom-input-error" id="body_error"></p>
                        </div>
                    </div>
                    <div class="modal-contact-section">
                        <div class="general-check">
                            <input type="checkbox" name="terms" id="contact_terms" class="custom-checkbox"
                                   value="1">
                            <label for="contact_terms" class="custom-checkbox-label">
                                <span></span>
                                <p>
                                    * Sunt de acord cu <a href="/page/termeni-si-conditii" target="_blank"
                                                          class="p-color"> Termenii si Conditiile </a>
                                    siteului.
                                </p>
                            </label>
                            <div class="check-error">
                            <span class="check-error-message" role="alert">
                                <p class="custom-input-error" id="terms_error"> </p>
                            </span>
                            </div>
                        </div>
<!--                        <div class="recaptcha-box">-->
<!--                            <div id="contact-recaptcha"></div>-->
<!--                            <div class="check-error">-->
<!--                            <span class="check-error-message" role="alert">-->
<!--                                <p class="custom-input-error" id="g-recaptcha-response_error"> </p>-->
<!--                            </span>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                    <div class="modal-footer custom-modal-footer">
                        <button type="button" class="general-btn negative-btn" data-dismiss="modal">
                            <i class="fad fa-times-circle"></i>
                            <span> Inchide </span>
                        </button>
                        <button type="button" class="general-btn positive-btn" @click="sendMessage">
                            <i class="fad fa-paper-plane"></i>
                            <span> Trimite Mesaj </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: "PublicContactModalProject",
    data() {
      return {
        project: null,
        model: null,
        message: '',
        email: this.$userEmail,
        phone: this.$userPhone,
        contactRecaptchaId: null
      }
    },
    mounted() {
      let vm = this
      $('#publicContactModalProject').on('hidden.bs.modal', function () {
        vm.project = null
        vm.model = null
        vm.message = ''
        // window.grecaptcha.reset(vm.contactRecaptchaId);
      });
      this.$eventBus.$on('OPEN_PUBLIC_CONTACT_MODAL_PROJECT', function (payLoad) {
        // vm.initProjectContactRecaptcha();
        vm.project = payLoad.project;
        vm.model = payLoad.model || null;
        if (vm.model) {
          vm.message = `Aş dori să primesc mai multe informaţii despre modelul ${ vm.model.rooms_count ? vm.model.rooms_count.name +' ' : ''} tip ${ vm.model.model_type }, din proiectul ${payLoad.project.name}`;
        } else {
          vm.message = `Aş dori să primesc mai multe informaţii despre proiectul ${payLoad.project.name}`;
        }
        $('#publicContactModalProject').modal('show');
      });
    },
    methods: {
      sendMessage() {
        let vm = this
        this.triggerLoader(true)
        window.resetErrors()
        let myForm = document.getElementById('publicContactModalProjectForm');
        let formData = new FormData(myForm);
        window.axios.post('/ajax/contact-project', formData)
          .then(function () {
            window.Swal.fire({
              html: 'Mesajul a fost trimis cu succes',
              icon: 'success',
              timer: 2000,
              showCancelButton: false,
              showConfirmButton: false
            }).then(() => {
              $('#publicContactModalProject').modal('hide')
              $('#publicContactModalProjectForm')[0].reset();
              $('#contact_terms').prop("checked", false);
              // window.grecaptcha.reset(vm.contactRecaptchaId);
              if (window.gtag) {
                window.gtag('event', 'conversion', { 'send_to': 'AW-440835022/w4MQCOvPsv4BEM63mtIB' });
              }
              if(window.fbq)
              {
                  window.fbq('track', 'Contact');
              }
            })
            vm.triggerLoader(false)
          })
          .catch(function (err) {
            window.showError(err, 'publicContactModalProjectForm')
            // window.grecaptcha.reset(vm.contactRecaptchaId);
            vm.triggerLoader(false)
          });
      },
      initProjectContactRecaptcha() {
        let vm = this;
        setTimeout(() => {
            if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.render ==='undefined')
                vm.initProjectContactRecaptcha();
            else
            {
                if(!vm.contactRecaptchaId)
                {
                    try {
                        vm.contactRecaptchaId = window.grecaptcha.render('contact-recaptcha', {
                            'sitekey' : process.env.MIX_RECAPTCHA_SITE_KEY,
                            'theme' : 'light',
                            'size' : 'normal'
                        });
                    } catch(err)
                    {
                        console.log(err);
                    }
                }
            }
        }, 200);
      }
    }
  }
</script>

<style scoped>

</style>
